export default {
    title: '操作确认',
    closeBtn: true,
    show: false,
    text: '',
    confirmText: '确定',
    clearText: '取消',
    align: 'center',
    clearCallback: '',
    confirmCallback: '',
};



// WEBPACK FOOTER //
// ./src/ui/confirm/store/state.js